import React, { useEffect, useState } from "react";
//i18n
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Button,
  Label,
  CardTitle,
  CardSubtitle,
  Spinner,
} from "reactstrap";
import { AvForm, } from "availity-reactstrap-validation";

// Redux
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select"
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { postSubmitForm } from "../../../helpers/forms_helper";
import showNotification from "../../../helpers/show_notification";
import { checkOutOfStock } from "../../../helpers/po_helper";
import { convertToLowestUnit, GetUpdatedDelivered, formatUnitsForReport } from "../../../helpers/units";
import { useRef } from "react";
import moment from "moment";
import EnterQuantityModal from "../../EnterQuantityModal";

const formatExpiryDate = (expiry_date) => {
  if (!expiry_date) return "N/A";
  const parsed = moment(expiry_date);
  return parsed.isValid() ? parsed.format("M/D/YYYY") : "N/A";
};

const ItemsDirectTransfer = (props) => {
  const [cartItems, setCartItems] = useState([]);
  const storeId = localStorage.getItem("store_id")
  const storeType = localStorage.getItem("store_type")

  const [selectedStore, setSelectedStore] = useState("");
  const [selectUnitModal, setSelectUnitModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState("")


  useEffect(() => {
    if (selectedItem) {
      loadAllBranchItemBatches();
    }
  }, [selectedItem]);

  useEffect(() => {
    if (props.allStores[0]?.type === "CENTRAL STORE" && storeType === "Sub Store") {
      setSelectedStore(() => props.allStores[0])
    }
  }, [props.allStores])


  const refSelectedBatch = useRef(null);
  const refSelectedItem = useRef(null);
  const [allBatches, setAllBatches] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState();
  const loadAllBranchItemBatches = async () => {
    console.log(selectedItem, "SI");
    let url = process.env.REACT_APP_BASEURL + "storeiteminventories/get_by_item_id";
    let response = await postSubmitForm(url, {
      item_id: selectedItem._id,
    });
    if (response.status === 1) {
      // const result = response.data.filter((store)=>store.store_name === storeName)
      const result = response.data
      const batchOptions = result.map(batch => ({
        ...batch,
        label: `${batch.batch} - Expiry: ${formatExpiryDate(batch.expiry_date)}`,
        value: batch._id
      }));

      setAllBatches(batchOptions);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleDeleteRow = (batch) => {
    setCartItems((prevCartItems) => {
      const updatedCartItems = prevCartItems.filter((item) => item.batch !== batch);
      return updatedCartItems;
    });
  };


  const columns_cartitems = [
    {
      dataField: "category",
      text: props.t("Category"),
    },
    {
      dataField: "sub_category",
      text: props.t("Sub-Category"),
    },
    {
      dataField: "name",
      text: props.t("Name"),
      sort: true,
    },
    {
      dataField: "batch",
      text: props.t("Batch"),
    },
    {
      dataField: "expiry_date",
      text: props.t("Expiry Date"),
      formatter: (cell, row) => {
               return row.expiry_date ? moment(row.expiry_date).format("DD/MM/YYYY") : '';
      },
    },
    {
      text: props.t("Transfer Quantity"),
      dataField: "quantity",
      sort: false,
      editable: false,
      formatter: (cell, row) => {
        return (
          <>
            {formatUnitsForReport(row.quantity)}
          </>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      footer: false,
    },

    {
      dataField: "",
      editable: false,
      text: "Remove",
      formatter: (cell, row) => {
        return (
          <span className="d-flex justify-content-center text-danger">
            <i
              className="bx bxs-trash font-size-20"
              title="Click to Remove"
              style={{ cursor: "pointer" }}
              onClick={() => {
                handleDeleteRow(row.batch)
              }}
            ></i>
          </span>
        );
      },
      headerStyle: (colum, colIndex) => {
        return { width: "8%" };
      },
      sort: false,
      footer: false,
    },
  ];

  const handleAddUnits = async (quantity) => {
    var new_array_items = JSON.parse(JSON.stringify(cartItems));
    const existing_item = new_array_items.filter(function (item) {
      return item.batch === selectedBatch.batch;
    });

    if (existing_item.length > 0) {
      showNotification(
        props.t("This item batch is already added."),
        props.t("Error")
      );
    } else if (selectedBatch) {
      let totalEntered = convertToLowestUnit(selectedItem?.unit_levels, quantity);
      let totalAvailable = convertToLowestUnit(selectedItem?.unit_levels, selectedBatch.quantity)
      if (totalEntered > totalAvailable) {
        showNotification("Can not enter more than available in batch", "Warning");
        return
      }
      let convertedQuantity = GetUpdatedDelivered(quantity, selectedItem?.unit_levels)
      let item_to_add = {};
      item_to_add.item_id = selectedItem?._id;
      item_to_add.batch = selectedBatch.batch;
      item_to_add.name = selectedItem?.name;
      item_to_add.category = selectedItem?.category;
      item_to_add.sub_category = selectedItem?.sub_category;
      item_to_add.brand = selectedItem?.brand;
      item_to_add.quantity = convertedQuantity.map(({ unit, value }) => ({ unit, value: parseFloat(value) })) || null;
      item_to_add.unit_levels = selectedItem?.unit_levels;
      item_to_add.is_free = selectedBatch?.is_free;
      item_to_add.expiry_date = selectedBatch?.expiry_date;
      item_to_add.cost_price = selectedBatch?.cost_price;
      item_to_add.selling_price = selectedBatch?.selling_price;
      setCartItems([...cartItems, item_to_add]);
      setSelectUnitModal(false);
      setSelectedItem("");
      setSelectedBatch();
      // refSelectedItem.current.select.clearValue();
    } else {
      showNotification(props.t("Select a item batch first."), props.t("Error"));
    }
  };
  // console.log(selectedRowsUnit,"SELECTED UNITS");
  // console.log(selectedBatch,"SELECTED Batch");
  const [isDisabled, setIsDisabled] = useState(false)
  const handleValidSubmit = async (e, v) => {
    try {
      setIsDisabled(true)
      const object = {
        transferredItems: cartItems,
        remarks: v.remarks,
        transferToStoreId: selectedStore && selectedStore._id,
        transferFromStoreId: storeId,
      };
      // console.log(object,"Payload");
      // return
      let url = process.env.REACT_APP_BASEURL + "storesitemstransfer/direct_transfer";
      let response = await postSubmitForm(url, object);

      if (response.status === 1) {
        setIsDisabled(false)
        setCartItems([]);
        setSelectedItem(null);
        setSelectedBatch();
        setAllBatches([]);
        if (selectedStore && props.onStoreSelect) {
          props.onStoreSelect(selectedStore);
        }
        showNotification(response.message, "Success");
      } else if (response.status === 2) {
        setIsDisabled(false)
        showNotification(response.message, "Warning");
      } else {
        setIsDisabled(false)
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsDisabled(false)
      showNotification(error, "Error");
    }
  };

  function handleCloseModal() {
    setSelectUnitModal(false);
    setSelectedBatch()
  }

  function handleSelectBatch(e) {
    setSelectedBatch(e)
    setSelectUnitModal(!selectUnitModal)
  }


  return (
    <React.Fragment>
      <Row>

        <Col lg={12}>
          <Card>
            <CardBody >
              <CardTitle>{props.t("Transfer Items")}</CardTitle>
              <CardSubtitle>{props.t("Enter the following details to initiate transfer of items")}</CardSubtitle>
              <AvForm>
                <Row className="mt-2">

                  <Col lg={4} hidden={props.allStores[0]?.type === "CENTRAL STORE" && storeType === "Sub Store"}>
                    <Label>{props.t("To")}</Label>
                    <Select
                      options={props.allStores}
                      placeholder={props.t("None")}
                      onChange={(se) => { setSelectedStore(se); setSelectedItem("");setCartItems([]); props.onStoreSelect(se) }}
                      value={selectedStore}
                      className="basic-single"
                      classNamePrefix="select"
                    />
                  </Col>

                  {selectedStore && (
                    <Col lg={4} >
                      <Label>{props.t("Item")}</Label>
                      <Select
                        // ref={refSelectedItem}
                        options={props.allItems}
                        placeholder={props.t("None")}
                        onChange={(se) => { setSelectedItem(se) }}
                        classNamePrefix="select2-selection"
                        value={selectedItem}
                        className="basic-single"

                      />
                    </Col>
                  )}

                  {selectedItem && (
                    <>
                      <Col lg={2}>
                        <br />
                        <Label>{`${localStorage.getItem("store_name")} Available`}</Label>
                        <br />
                        <Label>
                          {formatUnitsForReport(selectedItem?.store_available, selectedItem?.unit_levels)}
                        </Label>
                      </Col>
                      <Col lg={2}>
                        <br />
                        <Label>Threshold Quantity</Label>
                        <br />
                        <Label>
                          {selectedItem?.threshold +
                            " " +
                            selectedItem?.unit_for_threshold}
                        </Label>
                      </Col>
                    </>
                  )}



                  {selectedItem && checkOutOfStock(selectedItem?.store_available) ? (
                    <Col lg={4}>
                      <p class="text-muted mb-2">&nbsp;</p>
                      <div class="alert alert-danger fade show text-center" role="alert">
                        {props.t("This item is out of stock.")}
                      </div>
                    </Col>
                  )
                    : (
                      selectedItem && (

                        <Col lg={4}>
                          <br />
                          <Label>{props.t("Batch")}</Label>
                          <Select
                            ref={refSelectedBatch}
                            value={selectedBatch && selectedBatch}
                            key={selectedBatch}
                            onChange={(e) => { handleSelectBatch(e) }}
                            options={allBatches && allBatches}
                            classNamePrefix="select2-selection"
                            required
                          />
                        </Col>

                      )

                    )
                  }
                </Row>
              </AvForm>
              <hr />

              {cartItems.length > 0 && (
                <Row className="mt-5">
                  <Col lg={12}>


                    <ToolkitProvider
                      bootstrap4
                      keyField="item_id"
                      data={cartItems}
                      columns={columns_cartitems}
                      noDataIndication={props.t("No data to display.")}
                      search
                    >
                      {(props) => (
                        <div>
                          <BootstrapTable
                            striped
                            hover
                            condensed
                            {...props.baseProps}
                          />
                        </div>
                      )}
                    </ToolkitProvider>
                    <AvForm onValidSubmit={handleValidSubmit}>
                      <Row>
                        {/* <Col lg={6}>
                        <AvField
                          name="remarks"
                          value={remarks}
                          onChange={(e) => {
                            setRemarks(e.target.value);
                          }}
                          label={props.t("Remarks")}
                          placeholder={props.t("Enter Remarks")}
                          type="textarea"
                        />
                      </Col> */}
                        <Col lg={12}>
                          <hr />
                          <FormGroup className="mb-0 text-left">
                            <div>
                              <Button
                                type="submit"
                                color="primary"
                                style={{ width: '100px' }} 
                                disabled={isDisabled}
                                className="mr-1"
                              >
                            {isDisabled ? <Spinner size="sm" /> : props.t("Submit")} 
                              </Button>
                            </div>
                          </FormGroup>
                        </Col>
                      </Row>
                    </AvForm>

                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>




      {/* Add Quantity modal  */}
      <EnterQuantityModal
        isOpen={selectUnitModal}
        toggle={handleCloseModal}
        onSubmit={handleAddUnits}
        item={selectedItem}
        checkLimitFor={"batch"}
        selectedBatch={selectedBatch}
      />
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => { };
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(ItemsDirectTransfer))
);

